<ami-dialog-message [setting]="message"></ami-dialog-message>
<p-dialog
  [(visible)]="open"
  [closeOnEscape]="true"
  modal="modal"
  showEffect="fade"
  [keepInViewport]="false"
  [draggable]="false"
  header="Actualizar Unidad Medida"
  [style]="{ width: '600px' }"
  (onHide)="onClose()"
>
  <div class="grid">
    <div class="col-12">
      <form [formGroup]="fg">
        <div class="p-fluid p-formgrid grid">
          <div class="mt-3 mb-2">
            <p-fieldset legend="Datos" [toggleable]="true">
              <div class="p-fluid p-formgrid grid">
                <div class="field col-12 md:col-6">
                  <label>Código</label>
                  <input pInputText formControlName="code" type="text" />
                </div>
                <div class="field col-12 md:col-6">
                  <label>Serie de Comprobante</label>
                  <input
                    pInputText
                    formControlName="seriesOfReceipts"
                    type="number"
                    min="1"
                  />
                </div>
              </div>
            </p-fieldset>
          </div>
          <div class="mt-3 mb-2 field col-12 md:col-12">
            <pg-branch-store-details
              (onSelect)="branchStoreSelected.onSelect($event)"
              [legend]="branchStoreSelected.legend"
            ></pg-branch-store-details>
          </div>
          <div class="field col-12 md:col-8"></div>
          <div class="field col-12 md:col-2">
            <button
              pButton
              pRipple
              icon="pi pi-times"
              (click)="onClose()"
              class="p-button-text"
              label="No"
            ></button>
          </div>
          <div class="field col-12 md:col-2">
            <button
              (click)="onSubmit()"
              pButton
              pRipple
              icon="pi pi-check"
              class="p-button-text"
              [disabled]="fg.invalid"
              label="Si"
            ></button>
          </div>
        </div>
      </form>
    </div></div
></p-dialog>
